import { getUser, getToken } from "../../Utilities/Common";
import { postQrAPICallwithFile, postQrAPICall, postQrPrintAPICall, postQrPOSAPICallwithFile } from "../axiosMethodCall";

export const createPayment = async (params) => {
  try {
    // Build JSON payload for array fields to be sent as raw arrays
    const amtTypes = params.amount_and_types || [{ type: "cash", amount: 0.0 }];
    const typesArray = Array.isArray(amtTypes) ? amtTypes : [amtTypes];
    
    const payload = {
      requester: getUser(),
      token: getToken(),
      patient_id: params.patient_id || "",
      master_patient_id: params.master_patient_id || "",
      transaction_id: params.transaction_id || "",
      amount_and_types: typesArray.map((item) => ({
        type: item?.type || "cash",
        amount: typeof item?.amount === "number" ? item.amount : parseFloat(item?.amount || 0.0),
      })),
      grand_total: params.grand_total ?? 0.0,
      discount: params.discount ?? 0.0,
      payment_discount: params.payment_discount ?? 0.0,
      change: params.change ?? 0.0,
      charge_to: params.charge_to || "",
      is_senior: params.is_senior || 0,
      is_pwd: params.is_pwd || 0,
      additional_transaction: params.additional_transaction || "no",
      origin: "emr",
    };

    const response = await postQrAPICall(
      process.env.REACT_APP_LINK_CSR + "payments/create",
      payload
    );

    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const generateDotmatrix = async (params) => {
  try {
    const payload = {
      token: getToken(),
      requester: getUser(),
      company_name: params.company_name || "",
      vat_reg: params.vat_reg || "",
      min: params.min || "",
      sn: params.sn || "",
      ptu_no: params.ptu_no || "",
      invoice_no: params.invoice_no || "",
      date_time: params.date_time || "",
      items: params.items || [],
      subtotal: params.subtotal ?? 0,
      total_discount: params.total_discount ?? 0,
      vat_exemption: params.vat_exemption ?? "0.00",
      total: params.total ?? 0,
      payment_type: params.payment_type || "cash",
      paid_amount: params.paid_amount ?? 0,
      change: params.change ?? 0,
      vat_sales: params.vat_sales ?? "0.00",
      vat_exempt_sales: params.vat_exempt_sales ?? "0.00",
      zero_rated_sales: params.zero_rated_sales ?? 0,
      total_vat: params.total_vat ?? 0,
      vat_exempt: params.vat_exempt ?? "0.00",
      total_amount: params.total_amount ?? 0,
      senior_id: params.senior_id || "",
      customer_name: params.customer_name || "",
      amount: params.amount ?? 0,
      signature_date: params.signature_date || "",
      total_items: params.total_items ?? 1,
      cashier_name: params.cashier_name || "",
      reprint: params.reprint || "no",
      origin: "emr",
    };

    const response = await postQrAPICall(
      process.env.REACT_APP_LINK_CSR + "prints/generate_dotmatrix",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const generateReceipt = async (params) => {
  try {
    // Use FormData for binary file upload
    const formData = new FormData();
    formData.append("token", getToken());
    formData.append("requester", getUser());
    formData.append("printer", params.printer || "Cashier");
    formData.append("txtfile", params.txtfile);
    // Handle file upload - ensure proper filename for Blob/File objects
    // if (params.txtfile instanceof Blob) {
    //   formData.append("txtfile", params.txtfile, "queueSlip.txt");
    // } else if (params.txtfile) {
    //   formData.append("txtfile", params.txtfile);
    // }
    formData.append("open_cashdrawer", params.open_cashdrawer ?? 0);
    formData.append("emr_queue_no", params.emr_queue_no || "");
    
    // Add origin parameter - backend might differentiate kiosk vs EMR
    formData.append("origin", "emr");
    
    // Add name parameter for backend logic
    if (params.name) {
      formData.append("name", params.name);
    }

    console.log("FormData payload being sent:")
    for (let [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(`${key}:`, {
          name: value.name,
          size: value.size,
          type: value.type
        })
      } else {
        console.log(`${key}:`, value)
      }
    }
    
    const apiUrl = process.env.REACT_APP_POS_API || "https://api.myt-emr.com/clinicaprime-medease-pos-api/";
    console.log("API URL being called:", apiUrl + "prints/generateReceipt");
    
    console.log("Making API call to:", apiUrl + "prints/generateReceipt")
    console.log("API key being used:", process.env.REACT_APP_POS_API_KEY || process.env.REACT_APP_KEY_QR_PRINT)
    
    try {
      const response = await postQrPOSAPICallwithFile(
        apiUrl + "prints/generateReceipt",
        formData
      );
      
      console.log("API response status:", response.status)
      console.log("API response data:", response.data)
      console.log("API response headers:", response.headers)
      
      // Check if response actually indicates success
      if (response.data && response.data.message === 'Print jobs initiated') {
        console.log("✅ Backend accepted print job")
      } else {
        console.log("❌ Backend response unexpected:", response.data)
      }
      
      return { data: response.data };
    } catch (apiError) {
      console.error("❌ API call failed:", apiError)
      console.error("Error response:", apiError.response?.data)
      return { error: apiError.response }
    }
  } catch (error) {
    return { error: error.response };
  }
};

